import updateProfile from './updateProfile';
import convertToProfileView from './convertToProfileView';

export default (path, version = 'v1', namespace = 'afosto') => async (view, { views = [] }) => {
  try {
    const profileKey = view.key.replace(/^(me.|tenant.)/, '');
    const viewPath =
      view.type === 'user'
        ? `${namespace}.me.${path}.${version}.views.${profileKey}`
        : `${namespace}.tenant.${path}.${version}.views.${profileKey}`;
    const positionsPath = `${namespace}.me.${path}.${version}.positions`;

    await updateProfile(viewPath, convertToProfileView(view));
    await updateProfile(positionsPath, [...views.map(({ key: viewKey }) => viewKey), view.key]);

    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};
